/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

import React, { forwardRef, useRef } from 'react'
import { Dimensions, View } from 'react-native'
import { FaceHandler, FaceProps } from '@vatom/sdk/react'
import { VatomTokenType } from '@vatom/vatom/plugin'
import { observer } from 'mobx-react-lite'
import { useBreakpointValue, useTheme } from 'native-base'

import { useWebFace } from './useWebFace'
import { WebViewBase } from './WebView'

export function useMaxWith() {
  const theme = useTheme()
  const windowDimensions = Dimensions.get('window')
  return useBreakpointValue({
    base: windowDimensions.width,
    md: theme.breakpoints.sm,
    lg: theme.breakpoints.md
  })
}

let countRenders = 0

const WebFace = forwardRef<FaceHandler, FaceProps>((props, ref) => {
  const { token, viewMode, onMessage, style } = props

  const { face, onIncomingBridgeMessage, webviewRef } = useWebFace({
    token: token as VatomTokenType,
    viewMode,
    onMessage,
    ref
  })

  const wrapperRef = useRef<View>(null)

  countRenders++
  console.log('WebFace countRenders', countRenders)

  // TODO - return loading?
  if (!face) return null

  return (
    <View
      ref={wrapperRef}
      style={{
        alignItems: 'center',
        // maxWidth: Platform.OS === 'web' ? '600px' : height,
        width: '100%',
        height: '100%'
      }}
    >
      <WebViewBase
        viewMode={viewMode}
        onIncomingBridgeMessage={onIncomingBridgeMessage}
        webviewRef={webviewRef}
        wrapperRef={wrapperRef}
        // face={face}
        displayUrl={face.properties.display_url}
        style={style}
      />
    </View>
  )
})

Object.defineProperty(WebFace, 'name', {
  writable: true,
  value: 'WebFace'
})

export default observer(WebFace)
